import { render, staticRenderFns } from "./OrderBillDetail.vue?vue&type=template&id=307d3c42"
import script from "./OrderBillDetail.vue?vue&type=script&lang=js"
export * from "./OrderBillDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports